import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be0e495c&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=be0e495c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0e495c",
  null
  
)

export default component.exports